var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3535 15.3212C11.1582 15.126 10.8416 15.126 10.6463 15.3212L5.32126 20.6463C5.12599 20.8416 4.80941 20.8416 4.61415 20.6463L1.35348 17.3857C1.15822 17.1904 1.15822 16.8738 1.35348 16.6786L6.6786 11.3535C6.87387 11.1582 6.87387 10.8416 6.6786 10.6463L1.35348 5.32126C1.15822 5.12599 1.15822 4.80941 1.35348 4.61415L4.61415 1.35348C4.80941 1.15822 5.12599 1.15822 5.32126 1.35348L10.6463 6.6786C10.8416 6.87386 11.1582 6.87386 11.3535 6.6786L16.6786 1.35348C16.8738 1.15822 17.1904 1.15822 17.3857 1.35348L20.6463 4.61415C20.8416 4.80941 20.8416 5.12599 20.6463 5.32126L15.3212 10.6463C15.126 10.8416 15.126 11.1582 15.3212 11.3535L20.6463 16.6786C20.8416 16.8738 20.8416 17.1904 20.6463 17.3857L17.3857 20.6463C17.1904 20.8416 16.8738 20.8416 16.6786 20.6463L11.3535 15.3212Z",
    fill: "#A2B9E2",
    stroke: "#A2B9E2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossShape);
export default __webpack_public_path__ + "static/media/cross-shape.1cd3adc8d12ba41f43c0e7bb91c61844.svg";
export { ForwardRef as ReactComponent };